import {
  RugbyLeagueEventStatusId,
  RugbyLeagueIncidentId,
} from '@collector/sportsapi-client-legacy'

import { ManualAddIncidentConfig } from '../../../configuration'

export const manualAddIncidentConfig: ManualAddIncidentConfig<
  RugbyLeagueIncidentId,
  RugbyLeagueEventStatusId
> = {
  getKeyIncidents: () => [
    RugbyLeagueIncidentId.Try,
    RugbyLeagueIncidentId.PenaltyTry,
    RugbyLeagueIncidentId.ConversionGoal,
    RugbyLeagueIncidentId.ConversionMissed,
    RugbyLeagueIncidentId.ConversionAttempt,
    RugbyLeagueIncidentId.PenaltyKickGoal,
    RugbyLeagueIncidentId.PenaltyKickMissed,
    RugbyLeagueIncidentId.PenaltyAwarded,
    RugbyLeagueIncidentId.DropGoal,
    RugbyLeagueIncidentId.DropGoalMissed,
    RugbyLeagueIncidentId.YellowCard,
    RugbyLeagueIncidentId.RedCard,
    RugbyLeagueIncidentId.GreenCard,
    RugbyLeagueIncidentId.SubstitutionIn,
  ],
  otherIncidents: [
    RugbyLeagueIncidentId.FreeKick,
    RugbyLeagueIncidentId.EntryInto20,
    RugbyLeagueIncidentId.Kick,
    RugbyLeagueIncidentId.GoallineDropout,
    RugbyLeagueIncidentId.Offload,
    RugbyLeagueIncidentId.TackleBreak,
    RugbyLeagueIncidentId.Turnover,
    RugbyLeagueIncidentId.Foul,
    RugbyLeagueIncidentId.Scrum,
    RugbyLeagueIncidentId.Lineout,
  ],
  eventStatuses: [
    RugbyLeagueEventStatusId.FirstHalf,
    RugbyLeagueEventStatusId.SecondHalf,
    RugbyLeagueEventStatusId.Halftime,
    RugbyLeagueEventStatusId.WaitingForExtratime,
    RugbyLeagueEventStatusId.ExtratimeFirstHalf,
    RugbyLeagueEventStatusId.ExtratimeSecondHalf,
    RugbyLeagueEventStatusId.ExtratimeHalftime,
    RugbyLeagueEventStatusId.Penalties,
  ],
  layouts: {
    keyIncidentsLayout: {
      containerClass:
        'grid grid-flow-row grid-cols-2 @md:grid-cols-3 @lg:grid-cols-5 gap-1',
      buttonClass: '@lg:w-45!',
    },
    otherIncidentsLayout: {
      containerClass:
        'grid grid-flow-row grid-cols-2 @md:grid-cols-3 @lg:grid-cols-5 gap-1',
      buttonClass: '@lg:w-45!',
    },
    eventStatusesLayout: {
      containerClass:
        'grid grid-flow-row grid-cols-2 @md:grid-cols-3 @lg:grid-cols-5 gap-1',
      buttonClass: '@lg:w-45!',
    },
  },
}
